'use-strict';

import angular from 'angular';

import { FuelReceipt, FuelReceiptWithVehicle } from '../../src/app/@shared-types/fuel';
import { ApiService } from '../../src/app/shared/services/api';

export class FuelAPIService {
  private apiService: ApiService;

  constructor(apiService: ApiService) {
    'ngInject';

    this.apiService = apiService;
  }

  public getAll = (year?: number): Promise<FuelReceiptWithVehicle[]> => this.apiService
    .get<FuelReceiptWithVehicle[]>(`/api/vehicles/fuel-receipts${year ? `?year=${year}` : ''}`);

  public get = (receiptId: number): Promise<FuelReceiptWithVehicle[]> => this.apiService
    .get<FuelReceiptWithVehicle[]>(`/api/vehicles/fuel-receipts/${receiptId}`);

  public delete = (receiptId: number): Promise<void> => this.apiService
    .delete<void>(`/api/vehicles/fuel-receipts/${receiptId}`);

  public post = (receipt: Partial<FuelReceipt>): Promise<number> => this.apiService
    .post<number>('/api/vehicles/fuel-receipts', receipt);

  public put = (receipt: Partial<FuelReceipt>): Promise<number> => this.apiService
    .put<number>('/api/vehicles/fuel-receipts', receipt);
}

export default angular.module('services.fuelApiService', [])
  .service('fuelApiService', FuelAPIService)
  .name;
